export const settingColumnsConfig = {
    ID:"id",
     RULES:"Rules",
      ACTIONS: "Actions", // ✅ Added label for action column
    messages: "Are you sure you want to delete this setting?" // Optional: for ConfirmPopup
  
    };
    